import PropTypes from 'prop-types';

function IFBeveragesActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11309)">
                <path
                    d="M2.52895 5.34114L2.18585 2.94419L12.8411 1.69092L13.3176 3.80671L2.52895 5.34114Z"
                    fill="#F6A685"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.52903 5.3457C2.52903 5.3457 1.39965 8.91491 1.48066 10.4112C1.56167 11.9075 3.98244 28.0095 4.03963 28.3955C4.09681 28.7814 7.78992 29.8918 7.78992 29.8918C7.78992 29.8918 6.87498 14.1091 5.26431 9.27708C4.87355 8.09528 2.52903 5.3457 2.52903 5.3457Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.52899 5.34549C2.52899 5.34549 4.5733 8.20467 4.91164 9.7248C5.24998 11.2449 7.39436 29.944 7.77082 29.8915C8.14728 29.8391 18.6881 26.9371 18.731 26.6845C18.7739 26.4319 16.4627 9.32451 16.1673 8.64308C15.8718 7.96164 13.5082 3.77771 13.3081 3.8063L2.52899 5.34549Z"
                    fill="#F6A685"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.79938 17.888L8.37599 21.9528C8.39564 22.0907 8.4436 22.223 8.51684 22.3415C8.59008 22.4599 8.68702 22.562 8.80158 22.6412C8.91614 22.7204 9.04584 22.775 9.18253 22.8017C9.31923 22.8284 9.45996 22.8265 9.5959 22.7962L15.5811 21.4763C15.8251 21.4225 16.0405 21.2802 16.1857 21.0769C16.3309 20.8736 16.3956 20.6237 16.3674 20.3755L15.8909 16.2726C15.8756 16.1313 15.8306 15.9949 15.7588 15.8724C15.6871 15.7498 15.5901 15.6438 15.4744 15.5614C15.3587 15.479 15.2268 15.4221 15.0875 15.3944C14.9482 15.3666 14.8046 15.3687 14.6662 15.4005L8.57613 16.7824C8.33301 16.8383 8.11915 16.9821 7.97574 17.1863C7.83233 17.3904 7.76952 17.6403 7.79938 17.888V17.888Z"
                    fill="#2D2D2D"
                />
                <path
                    d="M21.6648 21.5475L24.9171 21.3006C26.1788 21.1971 27.3912 20.7641 28.433 20.0449C29.4083 19.3877 29.6594 17.5628 29.6092 16.2778C29.6219 15.7333 29.5221 15.1921 29.3162 14.688C29.1102 14.1838 28.8024 13.7276 28.4121 13.3478C27.4452 12.406 26.5286 12.3181 25.5366 12.1507C24.5446 11.9833 20.9323 12.3558 20.9323 12.3558L21.1081 14.051C21.736 13.9715 24.7162 13.3855 26.223 13.9547C27.7299 14.524 28.1107 15.3946 27.9433 17.3033C27.8136 18.7766 26.0514 19.35 24.7873 19.4463L21.5476 19.6975L21.6648 21.5475Z"
                    fill="#F7D46D"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.3304 9.36719C22.3304 9.36719 22.8829 14.0593 23.0126 15.7587C23.1424 17.4581 23.247 19.4965 23.268 20.363C23.268 21.0494 23.6279 23.1632 23.4103 23.5231C23.1926 23.8831 21.4472 25.2811 17.0104 25.3774C12.5736 25.4737 11.435 25.1681 11.1881 24.5026C10.9411 23.8371 10.87 20.3169 10.6314 17.2279L10.104 10.3006L22.3304 9.36719Z"
                    fill="#F7D46D"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.4123 10.8551C19.799 10.5842 22.506 9.88484 22.4586 9.29305C22.4113 8.70126 19.6275 8.44115 16.2409 8.71208C12.8543 8.983 10.1473 9.68238 10.1946 10.2742C10.242 10.866 13.0257 11.1261 16.4123 10.8551Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0838 10.899C11.4434 10.6269 14.5366 10.0619 15.5621 9.98652C16.5876 9.91118 18.5255 9.72701 19.2287 9.88606C19.6766 9.99775 20.117 10.1376 20.5472 10.3046C19.7592 10.5054 18.9596 10.6578 18.153 10.7609C17.4121 10.7944 12.8037 11.2087 12.0838 10.899Z"
                    fill="#2D2D2D"
                />
                <path
                    d="M17.5193 6.15326C17.7343 5.94417 17.8739 5.66972 17.9163 5.37284C17.9587 5.07596 17.9015 4.77339 17.7537 4.51247C17.462 4.05226 17.226 3.55909 17.0505 3.0433C17.0292 2.58727 17.1784 2.13964 17.469 1.7876"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.089 6.03191C19.3065 5.75078 19.441 5.4144 19.4772 5.06082C19.5135 4.70724 19.45 4.35057 19.2941 4.03116C18.9903 3.45777 18.7462 2.85465 18.5658 2.23132C18.5205 1.68622 18.6574 1.1415 18.9551 0.682617"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11309">
                    <rect width="30" height="30" fill="white" transform="translate(0.545898 0.287109)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFBeveragesActive;

IFBeveragesActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFBeveragesActive.defaultProps = {
    className: null,
    width: 28,
};
